module.exports = __webpack_public_path__ + "static/media/storage-showcase-poster.de283b99.png";